"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

// eslint-disable-next-line import/no-anonymous-default-export
var _default = function _default(heightFeetValue, heightInchesValue) {
  // convert imperial height to inches
  var heightTotalInches = parseInt(heightFeetValue, 10) * 12 + parseInt(heightInchesValue, 10); // convert inches to centimetres

  return Math.round(heightTotalInches * 2.54).toString();
};

exports["default"] = _default;